import { jsxs as j, jsx as m } from "react/jsx-runtime";
import { FileSourceEnum as k } from "@systemeio/file-manager";
import { useEditor as A, EditorContent as P } from "./node_modules/@tiptap/react/dist/index.mjs";
import U from "./_virtual/index.mjs";
import { useState as z, useEffect as h } from "react";
import { twMerge as g } from "tailwind-merge";
import { CharacterCount as q } from "./components/character-count.mjs";
import { baseExtensions as G } from "./constants/default-extensions.mjs";
import { EDITOR_PADDING as E } from "./constants/default-styles.mjs";
import { EditorExtensionEnum as H } from "./enums/editor-extensions-enum.mjs";
import { useImageDropAndUpload as W } from "./extensions/image-extension/use-image-drop-and-upload/index.mjs";
import { useInitContentWithLinkifiedText as _ } from "./extensions/link-extension/use-init-content-with-linkified-text.mjs";
import { Toolbar as J } from "./toolbar/index.mjs";
import { getExistingExtensions as K, getExtensions as Q } from "./utils/get-extensions.mjs";
import { convertStyleObjectToCss as V } from "./utils/style-helpers.mjs";
import { FontFamilyEnum as X } from "./extensions/font-family-extension/utils.mjs";
const ft = ({
  mode: d = "html",
  content: r,
  isPreFetching: u,
  isEditable: n = !0,
  extensions: l = G,
  className: b,
  toolbarStyles: x,
  characterCountHint: y,
  style: C,
  toolbarClassName: T,
  extensionOptions: o,
  showAllItems: I,
  skeletonClassName: v,
  defaultFont: S = X.TimesNewRoman,
  onBlur: a,
  onChange: w
}) => {
  var p;
  const D = ((p = o == null ? void 0 : o[H.Image]) == null ? void 0 : p.fileSource) ?? k.TextEditor, { onDrop: N, onPaste: F } = W(D), [f, L] = z(!1), i = d === "html" ? "getHTML" : "getText", s = Array.from(new Set(l)), { hasImage: c, hasCharacterCount: M, hasSimpleLink: R } = K(s), t = A({
    content: r,
    immediatelyRender: !1,
    onCreate: () => L(!0),
    extensions: Q(s, o),
    onUpdate: ({ editor: e }) => f && w(e.isEmpty ? "" : e[i]()),
    onBlur: ({ editor: e }) => f && (a == null ? void 0 : a(e.isEmpty ? "" : e[i]())),
    editorProps: {
      handlePaste: c ? F : void 0,
      handleDrop: c ? N : void 0,
      attributes: {
        class: g(
          "border",
          "border-text-secondary/30",
          "main-transition-colors",
          "min-h-[500px]",
          "w-full",
          "focus:outline-hidden",
          "focus:border-brand-primary",
          "overflow-auto",
          "rounded-b-lg",
          !n && "pointer-events-none cursor-default",
          b
        ),
        style: V({
          paddingLeft: E,
          paddingRight: E,
          fontFamily: S,
          ...C
        })
      }
    }
  });
  return _({
    editor: t,
    content: r,
    shouldInitialize: R && d === "text"
  }), h(() => {
    t && t.setOptions({ editable: n && !u });
  }, [n, u, t]), h(() => {
    if (!t) return;
    const e = U(() => {
      t[i]() !== r && t.commands.setContent(r ?? "", { emitUpdate: !1 });
    }, 300);
    return e(), () => {
      e.cancel();
    };
  }, [r, t, i]), t != null && t.isInitialized ? /* @__PURE__ */ j("div", { className: "relative", children: [
    l.length !== 0 && /* @__PURE__ */ m(
      J,
      {
        editor: t,
        extensions: s,
        toolbarStyles: x,
        toolbarClassName: T,
        showAllItems: I,
        extensionOptions: o
      }
    ),
    /* @__PURE__ */ m(P, { editor: t }),
    M && /* @__PURE__ */ m(
      q,
      {
        editor: t,
        hint: y,
        className: "ml-auto mt-2 mr-2 w-fit"
      }
    )
  ] }) : /* @__PURE__ */ m(
    "div",
    {
      className: g(
        "bg-background-tertiary h-[500px] w-full animate-pulse rounded-lg",
        v
      )
    }
  );
};
export {
  ft as TipTapEditor
};
